export const ORDER_TYPE_INSTALLMENTS = 'installments';
export const NOOSA_SESSION_ID = 'NoosaSessionId';
export var NPG_APP_VER = "developer_machine";

//export var NPG_APP_VER = "developer_machine";
NPG_APP_VER = "npg_staging_ff80871_1681022647152";
console.log ('NPG_APP_VER=' + NPG_APP_VER); 
